import Paper from '@material-ui/core/Paper';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import * as React from 'react';
import i18n from '../resources/i18n';
type Classes = 'root';

/**
 * スタイル指定
 * @param theme テーマ
 */
const styles = (theme: Theme) =>
	createStyles({
		root: {
			flexGrow: 1,
			margin: '1rem',
			padding: 24,
		},
	});

/**
 * CommonHelp のProps型
 */
interface IProps {
	/**
	 * スタイル指定
	 */
	classes?: Record<Classes, string>;
}

/**
 * ヘルプ画面共通コンポーネント
 * @param props
 */
const Logout: React.FC<IProps> = ({ classes }) => (
	<Paper className={classes ? classes.root : ''}>
		<Table>
			<TableBody>{i18n.t('Logout_0001')}</TableBody>
		</Table>
	</Paper>
);

/**
 * ヘルプ画面共通コンポーネント
 */
export default withStyles(styles)(Logout);



// WEBPACK FOOTER //
// ./src/components/Logout.tsx